import { useMediaQuery, Box, Theme } from '@mui/material';
import React, { ReactNode } from 'react';
import { LayoutProps } from './layouts';
import { Resources } from '../auth/authTypes';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

function Layout({ children, resourceName }: LayoutProps) {
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'invisible',
      }}
    >
      <Header selectedTab={resourceName} />
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'scroll',
        }}
      >
        {children}
        {/* Footer is not sticky to screen on desktop. Placed below content */}
        {!isSmall && <Footer />}
      </Box>
      {/* Footer is sticky to screen on mobile */}
      {isSmall && <Footer />}
    </Box>
  );
}
export const getLayout = (page: ReactNode, resourceName: Resources) => (
  <Layout resourceName={resourceName}>{page}</Layout>
);
export default Layout;
